package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_03_03_Day_1
import com.veldekar.components.logs.Log_2023_03_03_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-03-03")
@Composable
public fun Log_2023_03_03(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "The Shield Bearers' Quest",
        ogTitle = "The Shield Bearers' Quest",
        date = LocalDate(2_023, 3, 3),
        ogDescription = "The party joins a guild dedicated to repairing the Shield of Concar and prepares to brave the Imperial Darkway.",
        ogImage = "ai/2023-03-03.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-16", dateString = "Newgrowth 16")
        Log_2023_03_03_Day_1()
        SessionDayHeader(dayId = "newgrowth-17", dateString = "Newgrowth 17")
        Log_2023_03_03_Day_2()
    }
}
